// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

// document.domain="test.ximalaya.com"
import 'babel-polyfill'
import Vue from 'vue'
import App from './App'
import store from './vuex'
import './index.css'




Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  template: '<App/>',
  store,
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js